import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form'; 
import { useParams } from 'react-router-dom'; 
import toast from 'react-hot-toast';  
import moment from 'moment'; 
import { useAssetsApi } from '../../../../store/api/hooks/assetsApiHook';
import { useAppLoader } from '../../../../_common/pageLoader/appLoaderHook';
import Textarea from '../../../../components/elements/form/textarea';
import { showDate } from '../../../../_common/functions';
import { DATE_TIME_FORMAT } from '../../../../_common/constant';
import { useSpearPartsApi } from '../../../../store/api/hooks/spearPartsApiHook';

interface Note {
  id: number;
  content: string;
}

const Notes: React.FC = () => {
  const params: any = useParams();
  const assetsAPI = useAssetsApi();
   const spearPartsAPI = useSpearPartsApi();
  const [notes, setNotes] = useState<Note[]>([]);
  const { showLoader, hideLoader } = useAppLoader(); 
  const { control, reset, handleSubmit, formState: { errors } } = useForm<any>();

  const addNote = (value: any) => {
    const payload = {
      "objRequestModel": [
        { 
          "sparePartsNote": value.notes,
          "sparePartsID": params.id
        }
      ]
    }

    showLoader();
    spearPartsAPI.SavePartsNotes(payload, (data: any) => {
      hideLoader();
      clearnote();
      getNotesList(params.id);
      toast.success("Notes Added Successfully");
    }, (error: any) => {
      hideLoader();
    });
  };

  const deleteNote = (id: number) => {
    setNotes(notes.filter(note => note.id !== id));
  };
  const clearnote = () => {
    reset({ 'notes': '' });
  }

  const getNotesList = (sparePartsID: any) => {
    const payload = {
      sparePartsID: sparePartsID
    }
    showLoader();
    spearPartsAPI.GetPartsNotesList(payload, (data: any) => {
      hideLoader();
      if (data.sparePartsNotesList) {
        setNotes(data.sparePartsNotesList);
      } else {
        setNotes([]);
      }

    }, (error: any) => {
      hideLoader();
    });
  };

  useEffect(() => {
    if (params.id) {
      getNotesList(params.id);
    } 
  }, [params]);

  return (
    <div>
      {/* <div className='flex justify-between border-b border-gray-200 items-center py-2 mb-3'>
        <h4 className='font-semibold text-[0.938rem] py-4'>Write Your Notes Here</h4>
        <button className='bg-white border border-gray-400 text-black text-sm px-5 py-3 rounded-md font-bold hover:bg-[#f3f3f3] shadow-md'> ⋮ </button>
      </div> */}
      <form className="w-full" onSubmit={handleSubmit(addNote)}> 
        <Controller
          name='notes'
          control={control}
          rules={{ required: 'Notes required' }}
          render={({ field: { value, onChange } }) => (
            <Textarea
              label='Notes'
              value={value}
              onChange={onChange}
              placeholder='Write Your Notes Here...'
              error={errors?.notes?.message as any}
            />
          )}
        />
        <div className='flex justify-end pb-5 gap-2'>
          <button type='submit' className='bg-success border border-success text-white text-sm px-8 py-2 rounded-md font-medium hover:bg-[#666666] hover:border-[#666666]'>Add</button>
          <button type='button' onClick={clearnote} className='bg-secondary border border-secondary text-white text-md px-6 py-2 rounded-md font-medium hover:bg-[#7b5f54] hover:border-[#7b5f54]'> Clear </button>
        </div>
      </form>

      <ul className='p-3 bg-gray-50 rounded-md border border-gray-300 max-h-[25.25rem] overflow-y-scroll'>
        {notes.length === 0 && <div className='flex justify-center items-center text-black font-semibold'> No Record's Found</div>}
        {notes?.map((note: any) => (
          <li className='text-[#323233] text-[0.938rem]'>
            <p className='p-5 bg-gray-100 rounded-md border border-gray-300'>{note?.sparePartsNote}</p>
            <div className='flex justify-end mt-1 mb-4'>By: {note?.addedByName} on {showDate(note?.addedDate, DATE_TIME_FORMAT)}</div>
          </li>
        ))}

      </ul>
    </div>
  );
};

export default Notes;